export default __webpack_public_path__ + "static/media/fusion-011.2840e1c8.svg";